import App from '../../vendor_core/core/src/App';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IBuyFeatureConfig from '../../vendor_core/core/src/managers/contracts/configurations/IBuyFeatureConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';
import Configs from '../../vendor_core/src/vendorConfigs/Configs';

class BuyFeatureConfig implements IBuyFeatureConfig {
    type: ConfigurationTypes = ConfigurationTypes.BUY_FEATURE;
    betMultiplier: number[] = [100, 100, 100];
    maxFeaturePurchasePrice? : number;
    buyFeatureRtp: number[] = [1000, 1000, 1000];
    betOptions = [];
    mode: number = 0;
    creditPerBetBuyFeat: number = 0;
    public getBetOptions() {
        let result = [];
        if (this.betOptions.length > 0) {
            this.betOptions.forEach(bet => {
                if (this.betOptions.includes(bet)) {
                    result.push(bet)
                }
            })
        } else {
            result = Configs.bet.getBetOptions();
        }

        return result
    };

    public parseConfig(data: any) {
        if (data?.config?.buyFeatureCost) {
            this.betMultiplier = typeof data.config.buyFeatureCost === "number"
                ? [data.config.buyFeatureCost]
                : data.config.buyFeatureCost
        }

        if (data?.config?.buyFeatureRtp) {
            let bfRTP = typeof data.config.buyFeatureRtp === "number"
                ? [data.config.buyFeatureRtp * 100]
                : data.config.buyFeatureRtp.map((rtp) => rtp * 100)

            this.buyFeatureRtp = bfRTP;
        }

        if (data?.config?.creditsPerBet) {
            this.creditPerBetBuyFeat = data.config.creditsPerBet[2];
        }

        if (data?.limits?.maxFeaturePurchasePrice) {
            this.maxFeaturePurchasePrice = data.limits.maxFeaturePurchasePrice;
        }

        if (App.config.legalBetsHaveToBeModified) {
            this.betOptions = data.limits.legalBets.map(bet => (bet * this.creditPerBetBuyFeat) / this.betMultiplier[this.mode]);   
        }
    }
}

export default new BuyFeatureConfig()
